import { PlayerTypes, Teams } from "../types/Player";
import { TrainerTypes } from "../types/Trainer";

const teamsFilenames: { [key in Teams]: string } = {
  "Shining Angels": "angels",
  "Cruel Pumas": "pumas",
  "Mystic Unicorns": "mystic-unicorns",
  "Zenonia Knights": "zenonia-knights",
  "River City": "rivercity",
  "Forest Elves": "forest-elves",
};

const getTeamImage = (team: Teams) => {
  const filename = teamsFilenames[team];
  return `/images/teams/${filename}.png`;
};

const getTrainerImage = (trainerName: string) => {
  return encodeURIComponent(`/images/trainers/${trainerName}.png`);
};

const getTypeImage = (type: TrainerTypes | PlayerTypes) => {
  return `/images/types/${type}.png`;
};

const getUpgradeImage = (active = false) => {
  const filename = active ? "UpgradeActive" : "UpgradeInactive";
  return `/images/${filename}.png`;
};

const ImagesUtils = {
  getTeamImage,
  getTrainerImage,
  getTypeImage,
  getUpgradeImage,
};

export default ImagesUtils;
